import axios from 'axios';
import store from '@/store/store';
import { Route } from 'vue-router';

function isActiveFlag(active: unknown): boolean {
    if (active === true || active === 'true') {
        return true;
    }
    if (active && typeof active === 'object' && (active as { content?: unknown }).content === true) {
        return true;
    }
    return false;
}

function collectProjectRoles(projectId: string | number): string[] {
    const roles =
        store.state.account.getParticipantAuthority.data?.participantAuthorities?.map(
            (a) => a.authority
        ) || [];
    const accountRoles =
        store.state.account.getAccount.data?.projectRoles?.[projectId as any] ||
        store.state.account.getAccount.data?.projectRoles?.[+projectId] ||
        store.state.account.getAccount.data?.projectRoles?.[String(projectId) as any] ||
        [];
    return [...roles, ...accountRoles].map((r) => String(r).toUpperCase());
}

/** PO (pre-demotion) or UPO may stay when inactive. */
function isOwnerAllowedWhenInactive(projectId: string | number): boolean {
    return collectProjectRoles(projectId).some((name) => {
        const normalized = name.replace(/^ROLE_/, '');
        return (
            normalized === 'UNLICENCED_PROJECT_OWNER' ||
            normalized === 'PROJECT_OWNER'
        );
    });
}

/**
 * Kick only when we know the caller is PR/R (not owner).
 * If roles are not loaded yet, do not kick — avoids UPO false redirects to /projects.
 */
function shouldKickWhenInactive(projectId: string | number): boolean {
    const names = collectProjectRoles(projectId);
    if (names.length === 0) {
        return false;
    }
    if (isOwnerAllowedWhenInactive(projectId)) {
        return false;
    }
    return names.some((name) => {
        const normalized = name.replace(/^ROLE_/, '');
        return (
            normalized === 'REVIEWER' ||
            normalized === 'PRIVILEGED_REVIEWER'
        );
    });
}

/** Kick PR/R when PO license expired; PO/UPO stay. */
export async function enforceProjectLicenseAccess(to: Route): Promise<boolean> {
    const projectId = to.params.projectId;
    if (!projectId || !/^\d+$/.test(String(projectId))) {
        return true;
    }

    try {
        const { data: active } = await axios.get(
            `${process.env.VUE_APP_SUMARI_SERVER_URL}/projects/${projectId}/active`
        );
        if (isActiveFlag(active)) {
            return true;
        }
        if (!shouldKickWhenInactive(projectId)) {
            return true;
        }
        window.location.replace(`${process.env.VUE_APP_PROXY_CLIENT_URL}/#!/projects`);
        return false;
    } catch {
        return true;
    }
}
